var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-main',[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.tabsKey),callback:function ($$v) {_vm.tabsKey=$$v},expression:"tabsKey"}},[_c('el-tab-pane',{attrs:{"name":"user","label":"美容師"}},[_c('user')],1),_c('el-tab-pane',{attrs:{"name":"shop","label":"店櫃"}},[_c('shop')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }